export class CloudPrincipalInput {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "aws",
            "baseName": "aws",
            "type": "CloudPrincipalInputAws",
            "format": ""
        },
        {
            "name": "gcp",
            "baseName": "gcp",
            "type": "CloudPrincipalInputGcp",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return CloudPrincipalInput.attributeTypeMap;
    }
    constructor() {
    }
}
